import {Component, Input, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { DashboardService } from "../../services/dashboard.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ClustersService } from 'src/app/services/clusters.service';
import { Cluster } from 'src/app/models/cluster.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  intensityChart;
  ratingChart;

  displayedColumns: string[] = ['creationDate', 'name', 'zone', 'weight'];
  dataSource: MatTableDataSource<Cluster>;
  zoneChart;

  portfolioCardCharts;
  benchmarkCardCharts;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  clusterList: Cluster[];
  clusterListSubscription: Subscription;

  totalAUM: number;
  currencyBreakdown;
  investmentZoneBreakdown;

  constructor(private clustersService: ClustersService,
              private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.portfolioCardCharts = this.dashboardService.portfolioCardCharts();
    this.benchmarkCardCharts = this.dashboardService.benchmarkCardCharts();

    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);

    this.clusterListSubscription = this.clustersService.clusterListSubject.subscribe(
      (clusterList: Cluster[]) => {
        if (clusterList.length>0) {
          this.clusterList = clusterList;

          this.totalAUM = clusterList.map(cluster => cluster.aum).reduce((a,b) => (a+b));

          this.dataSource = new MatTableDataSource<Cluster>(clusterList);
          this.dataSource.paginator = this.paginator;

          let currencyAUM = {};
          clusterList.forEach(cluster => {
            if (currencyAUM[cluster.currency.id]==undefined) {
              currencyAUM[cluster.currency.id] = {
                aum: 0,
                pct: 0,
                currency: cluster.currency,
              };
            }
            currencyAUM[cluster.currency.id].aum += cluster.aum;
            currencyAUM[cluster.currency.id].pct += 100*cluster.aum/this.totalAUM;
          });
          this.currencyBreakdown = Object.values(currencyAUM);

          let investmentZoneAUM = {};
          clusterList.forEach(cluster => {
            if (investmentZoneAUM[cluster.investment_zone.id]==undefined) {
              investmentZoneAUM[cluster.investment_zone.id] = {
                aum: 0,
                pct: 0,
                investment_zone: cluster.investment_zone,
              };
            }
            investmentZoneAUM[cluster.investment_zone.id].aum += cluster.aum;
            investmentZoneAUM[cluster.investment_zone.id].pct += 100*cluster.aum/this.totalAUM;
          });
          this.investmentZoneBreakdown = Object.values(investmentZoneAUM);

          this.zoneChart = this.investmentZoneBreakdown.map((d) => {
            return {
              name: d.investment_zone.name,
              y: d.pct,
            }
          });

          let intensityChart = [];
          clusterList.forEach(cluster => {
            if (cluster.protected_analysis) {
              intensityChart.push({
                name: cluster.name,
                x: cluster.protected_analysis.effective_nb_of_factors,
                y: cluster.protected_analysis.factor_intensity,
              });
              return;
            } else if (cluster.investable_analysis) {
              intensityChart.push({
                name: cluster.name,
                x: cluster.investable_analysis.effective_nb_of_factors,
                y: cluster.investable_analysis.factor_intensity,
              });
              return;
            } else if (cluster.original_analysis) {
              intensityChart.push({
                name: cluster.name,
                x: cluster.original_analysis.effective_nb_of_factors,
                y: cluster.original_analysis.factor_intensity,
              });
              return;
            }
          });
          this.intensityChart = intensityChart;

          let ratingChart = [{
            name: 'Original',
            data: [0, 0, 0, 0, 0, 0]
          }, {
            name: 'Investable',
            data: [0, 0, 0, 0, 0, 0]
          }, {
            name: 'Protected',
            data: [0, 0, 0, 0, 0, 0]
          }];
          clusterList.forEach(cluster => {
            if (cluster.original_analysis) {
              ratingChart[0].data[5-cluster.original_analysis.global_robustness_rating] +=1;
            }
            if (cluster.investable_analysis) {
              ratingChart[1].data[5-cluster.investable_analysis.global_robustness_rating] +=1;
            }
            if (cluster.protected_analysis) {
              ratingChart[2].data[5-cluster.protected_analysis.global_robustness_rating] +=1;
            }
          });
          this.ratingChart = ratingChart;
        }
      }
    );
    this.clustersService.loadClusterList();
  }

  ngOnDestroy() {
    this.clusterListSubscription.unsubscribe();
  }

}
